import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@playbooks/ui/components/card';
import { Skeleton } from '@playbooks/ui/components/skeleton';
import { cn } from '@playbooks/ui/lib/utils';
import { buildArray } from '@playbooks/utils';

import type { SkeletonCountProps } from './types';

const SectionSkeleton = ({ count = 3, className = '' }: SkeletonCountProps) => {
	// Theme
	const rootClassName = cn('p-4', className);

	// Render
	return (
		<Card className={rootClassName}>
			<span className='flex-between gap-4 w-full'>
				<span className='flex-start gap-4 w-full'>
					<CardHeader className='aspect-[1/1] rounded-control w-8'>
						<Skeleton />
					</CardHeader>
					<CardContent className='w-full'>
						<CardTitle>
							<Skeleton className='w-1/4' />
						</CardTitle>
						<CardDescription>
							<Skeleton className='w-1/2' />
						</CardDescription>
					</CardContent>
				</span>
				<span className='aspect-[1/1] shrink-0 w-8'>
					<Skeleton />
				</span>
			</span>
			<CardContent className='w-full py-4'>
				<div className='grid w-full gap-3 grid-cols-10'>
					{buildArray(count).map((v, i) => (
						<div key={i} className='col-span-2'>
							<CardHeader className='aspect-[1/1]'>
								<Skeleton />
							</CardHeader>
						</div>
					))}
				</div>
			</CardContent>
		</Card>
	);
};
export { SectionSkeleton };
// Docs:
// https://github.com/dvtng/react-loading-s#readme
